import { render } from "./arrows-news.vue?vue&type=template&id=3b818dbc"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/arrows-news.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b818dbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b818dbc', __exports__)) {
    api.reload('3b818dbc', __exports__)
  }
  
  module.hot.accept("./arrows-news.vue?vue&type=template&id=3b818dbc", () => {
    api.rerender('3b818dbc', render)
  })

}


export default __exports__